<template>
  <el-table-column v-if="editable===false"
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
  />
  <el-table-column v-else
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <el-form-item
        :prop="tableDataName + '.' + scope.$index + '.' + prop"
        :rules="rules"
      >
          <!-- :value="getter(scope.row[prop])" -->
          <!-- @input="setter" -->
        <el-input
          v-model="scope.row[prop]"
          @blur="setter($event.currentTarget.value)"
          type="text"
          :clearable="true"
          :maxlength="maxlength"
          resize="none"
          :placeholder="placeholder"
          :disabled="disabled === true ? disabled : addRowMode === false ? disabled : !changeable(addRowMode, changeCase, tableDataCount, scope.$index)"
          :autofocus="autofocus"
          :validator="validator"
          :uppercase="uppercase"
        >
        </el-input>
      </el-form-item>
    </template>
  </el-table-column>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '減免率'
    },
    prop: {
      type: String,
      default: 'exemption_rate'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 4
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    validator: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: ''
    },
    addRowMode: {
      type: Boolean,
      default: false
    },
    changeable: {
      type: Function,
      default: () => true
    },
    changeCase: {
      type: String,
      default: ''
    },
    tableDataCount: {
      type: Number,
      default: 0
    },
    tableDataName: {
      type: String,
      default: 'tableData'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    rules: {
      get () {
        const rules = []
        // if (!this.disabled) {
        if (this.required) {
          rules.push(this.validatorRequired(this.label, 'blur'))
        }
        rules.push(this.validatorRegExp(this.label, '^[0-9]{1,2}/[0-9]{1,2}$', '分数', 'blur'))
        if (this.value) {
          rules.push(this.validatorFractionCheck(this.label, 'blur'))
        }
        // }
        return rules
      }
    }
  },
  mounted () {
    const root = document.documentElement
    root.style.setProperty('--width', this.width)
  },
  methods: {
    getter (value) {
      return value
    },
    setter (value) {
      if (this.uppercase) {
        this.$emit('input', value.toUpperCase())
      } else {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:root {
  --width: 100px;
}
.el-table {
  th,
  td {
    &.text-column {
      width: var(--width);
    }
  }
}
</style>
